import { Auth } from "./auth";
import { http } from "./base/http";
import { CheckoutInfo } from "./checkoutInfo";
import { CheckoutPayment } from "./checkoutPayment";
import { Common } from "./common";
import { AddressInfo } from "@/core/api/addressInfo";
import { Basket } from "./basket";

export const auth = new Auth(http);
export const checkoutInfoClient = new CheckoutInfo(http);
export const checkoutPaymentClient = new CheckoutPayment(http);
export const addressClient = new AddressInfo(http);
export const commonClient = new Common(http);
export const basketClient = new Basket(http);
